import { render, staticRenderFns } from "./SelectResidence.vue?vue&type=template&id=5d82e067&"
import script from "./SelectResidence.vue?vue&type=script&lang=js&"
export * from "./SelectResidence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports